import { Component, OnInit, ViewChild } from '@angular/core';

import { PlatformApiService } from 'src/app/services/platform-api.service';
import { Brand } from 'src/app/models/AccountModel';
import { BrandListComponent } from '../admin/brand-list.component';
import { SessionService } from 'src/app/services/session.service';

@Component({
  selector: 'app-brand-dashboard',
  templateUrl: './brand-dashboard.component.html',
  styleUrls: ['./brand-dashboard.component.scss']
})
export class BrandDashboardComponent implements OnInit {

  state = 'LIST';
  selectedItem: Brand;

  @ViewChild(BrandListComponent) brandList: BrandListComponent;

  constructor(private _platformApi: PlatformApiService, public _sessionService: SessionService) { }

  ngOnInit() {
  }

  showAllBrands() {
    this.selectedItem = undefined;
    this.state = 'LIST'
  }

  onStateChange(event) {
    switch (event.state) {
      case 'CREATE':
        this.selectedItem = new Brand();
        this.state = 'CREATE';
        break;
      case 'SELECT':
      case 'EDIT':
        this.selectedItem = event.item;
        this.state = 'EDIT';
        break;
      case 'CREATESUCCESS':
      case 'EDITSUCCESS':
      case 'REVERTTODEFAULT':
      case 'CREATECANCEL':
      case 'EDITCANCEL':
        this.selectedItem = undefined;
        this.state = 'LIST';
        break;
    }
  }

}
